import QuantitySelector, { SIZE } from '@dustin-web/microsite-components/src/quantity-selector'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

const CartItemQuantity = ({
  onSetQuantity,
  quantity,
  product,
  isMandatoryAccessory,
  disableEditing = false,
  isFirstItem,
  parentQuantity,
}: {
  quantity: number
  onSetQuantity: (q: number, b?: string) => void
  product: CartItemFragment['product']
  isMandatoryAccessory: boolean
  disableEditing?: boolean
  isFirstItem: boolean
  parentQuantity?: number
}) => {
  const { translate } = useTranslations()

  if (!product) {
    return null
  }

  const isAvailableForSale = product.availability?.isAvailableForSale
  parentQuantity = parentQuantity || 0

  let maxQuantity = product.maxQuantityPerOrder || 0
  if (parentQuantity > 0 && (maxQuantity >= parentQuantity || maxQuantity === 0)) {
    maxQuantity = parentQuantity
  }

  return (
    <div>
      {isFirstItem && (
        <span className="c-shoppingcart__column-header">{translate('Cart_Quantity')}</span>
      )}
      {!isFirstItem && <span className="visually-hidden">{translate('Cart_Quantity')}</span>}
      {isAvailableForSale && !disableEditing ? (
        <QuantitySelector
          productName={product.displayName}
          quantity={quantity}
          minQuantity={product.minQuantityPerOrder || 1}
          maxQuantity={maxQuantity}
          setQuantity={(quantity, originDigital) =>
            maxQuantity && quantity > maxQuantity
              ? undefined
              : onSetQuantity(quantity, originDigital)
          }
          debounce={true}
          size={SIZE.SMALL}
          isMandatoryAccessory={isMandatoryAccessory}
        />
      ) : (
        isAvailableForSale && <div>{quantity}</div>
      )}
    </div>
  )
}

export default CartItemQuantity
